import clockIcon from "../../images/clockIcon.svg";
import trashIcon from "../../images/trashIcon.svg";
import checkCircleIcon from "../../images/checkCircleIcon.svg";
import calendarIcon from "../../images/calendarIcon.svg";
import { useState } from "react";
import DoneModal from "./doneModal";
import { PostService } from "../../services/genericPostService";
import Swal from "sweetalert2";
import { resources_EN } from "../componentUtils";

const TodoCard = ({
  task_image,
  task_title,
  isPage = false,
  task_start_time,
  task_end_time,
  task_id,
  getTasks,
  task_date,
  task_desc,
  getHomeData,
  task_status,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userId = localStorage.getItem("userId");

  const doneTask = () => {
    const data = {
      task_id: task_id,
      user_id: userId,
    };

    const url = "/fmeApi/task_done.php";
    PostService(url, data, modal);
  };

  /* Confirmation Modal */
  const doneModal = () => {
    Swal.fire({
      title: "Er du sikker?",
      text: "Har du løst din opgave?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Opgave afsluttet",
    }).then((result) => {
      if (result.isConfirmed) {
        doneTask();
      }
    });
  };

  /* Generic Modal */
  const modal = (icon, title, message) => {
    if (icon === resources_EN.success) {
      setIsModalOpen(true);
    } else {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
      });
    }
  };
  console.log("Task Time", task_start_time);

  const closeModal = () => {
    getHomeData();
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="bg-theme rounded-xl p-4 overflow-hidden shadow">
        <div className="bg-white w-full h-32 p-5 rounded-lg">
          <img
            src={"../../fmeApi/" + task_image || "/placeholder.svg"}
            alt={task_title}
            className="w-full h-full object-contain "
          />
        </div>
        <div className="pt-4 pb-1">
          <h5 className="text-sm text-white mb-1 font-bold">{task_title}</h5>
          <p className="text-xs text-white mb-4">{task_desc}</p>
          <div className="flex flex-col text-md font-semibold">
            <div className="flex items-center mb-3 text-white text-sm">
              <img
                src={calendarIcon}
                className="mr-1 brightness-[999]"
                alt=""
              />
              {task_date}
            </div>
            <div className="flex items-center text-white text-sm">
              <img src={clockIcon} className="mr-1 brightness-[999]" alt="" />
              {task_start_time}-{task_end_time}
            </div>
            {+task_status !== 1 ? (
              <div className="flex justify-between gap-2 text-sm mt-8">
                <button
                  onClick={doneModal}
                  className="flex text-green items-center"
                >
                  <img src={checkCircleIcon} className="mr-1" alt="" />
                  Marker det som udført
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      {/* Modal Component */}
      <DoneModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default TodoCard;
